module.exports = __webpack_public_path__ + "static/media/25531821_1703515863056931_413820033228893611_o.b6fc3b70.jpg";